<template>
  <Header v-if="i > 1210" class="header_box" />
  <HeaderPE v-if="i < 1210" class="header_box" />
  <div v-if="i < 1210" class="zhanwei"></div>
  <main class="main_box" @mousewheel="scrollChange">
    <router-view></router-view>
  </main>
</template>

<script setup>
import Header from "@/components/Header.vue";
import HeaderPE from "@/components/HeaderPE.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref, watch } from "vue";
const store = useStore();
const router = useRouter();
const scrollChange = (res) => {
  store.state.offsetY = res.pageY;
};
let i = ref(window.innerWidth);
const isMobile = () => {
  const userAgentInfo = navigator.userAgent;
  const mobileAgents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  const mobileFlag = mobileAgents.some((mobileAgent) => {
    return userAgentInfo.indexOf(mobileAgent) > 0;
  });
  return mobileFlag;
};
if (isMobile()) {
  i.value = 800;
  router.push({
    path: "/homePE",
  });
} else {
  i.value = 1800;
  router.push({
    path: "/home",
  });
}
</script>

<style lang="less" scoped>
.zhanwei {
  width: 100%;
  height: 128px;
}
.header_box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
}
.main_box {
  box-sizing: border-box;
  padding-top: 0px;
}
</style>
